import React from 'react';
import { formatCurrency } from '../common/common';
import { useTenantCurrency, useExchangeRate } from '../common/currencyutils';

const LocationMargin = ({ location }) => {
    const currency = useTenantCurrency(location.customer && location.customer.tenantCompanyClusterId);
    const exchangeRate = useExchangeRate(currency);

    return (
        <React.Fragment>
            {formatCurrency(location.margin(exchangeRate), 2, currency)} ({location.marginPercentage(exchangeRate)}%)
            {!location.allProductsHaveProdPrice() && (
                <em>
                    <br />
                    Huom! Kohteessa käytössä tuotteita, joille ei löydy ostohintaa, katelaskelma on vajavainen!
                </em>
            )}
        </React.Fragment>
    );
};

export default LocationMargin;
